export default __webpack_public_path__ + "static/source-sans-pro-latin-400-italic-966e51f147bbf4f4fadd05c81e59386c.woff";